import Auth from "./auth";

const KEY_TOUR = 'tours';

const getTours = () => localStorage.getItem(KEY_TOUR); 
const setTours = tours => localStorage.setItem(KEY_TOUR, JSON.stringify(tours)); 
const resetTours = () => localStorage.removeItem(KEY_TOUR);

const disable = () => {
  const user_id = Auth.getUserId();
  let tours = JSON.parse(getTours(user_id)) || [];
  tours[user_id] = {
    showTour: false
  }
  setTours(tours);
};

const enable = () => {
  const user_id = Auth.getUserId();
  let tours = JSON.parse(getTours(user_id)) || [];
  tours[user_id] = {
    showTour: true
  }
  setTours(tours);
};


const show = () => {
  const user_id = Auth.getUserId();
  let tours = JSON.parse(getTours(user_id));
  return tours === null || tours[user_id] === undefined || tours[user_id] === null || tours[user_id].showTour === true
};

export default {
    enable,
    disable,
    show,
    resetTours
}



// WEBPACK FOOTER //
// ./src/store/tour.js